import { render, staticRenderFns } from "./DisponibilidadeEstoque.vue?vue&type=template&id=3ea4163c&scoped=true"
import script from "./DisponibilidadeEstoque.vue?vue&type=script&lang=js"
export * from "./DisponibilidadeEstoque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea4163c",
  null
  
)

export default component.exports